import { render, staticRenderFns } from "./authTree.vue?vue&type=template&id=c46186e0&scoped=true&"
import script from "./authTree.vue?vue&type=script&lang=js&"
export * from "./authTree.vue?vue&type=script&lang=js&"
import style0 from "./authTree.vue?vue&type=style&index=0&id=c46186e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46186e0",
  null
  
)

export default component.exports